<div *ngIf="memoHtml?.length > 0" class="page-layout carded left-sidenav toolbar-fixed-layout">
  <mat-sidenav-container>
    <div class="center pdf-container">
      <div class="mat-white-bg">
        <div class="content pos-relative p-30 flex flex-col">
          <div class="for-pdf" [innerHTML]="memoHtml | sanitizeHtml">
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
  <div class="form-footer flex flex-row justify-end items-center">
    <button mat-flat-button class="orbitax-footer-action-button" type="button" color="accent" (click)="done()">
      Done
    </button>
  </div>
</div>

